<!-- INPUT APP CALENDAR -->
<mat-form-field appearance="outline" *ngIf="ctx.isApp">
  <mat-label>{{ i18 | translate }}</mat-label>
  <input
    matInput
    placeholder="DD/MM/YYYY"
    [min]="minDate"
    [max]="maxDate"
    [matDatepicker]="picker"
    [value]="initValue"
    (dateChange)="onSelectDate($event)"
    required
  />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker touchUi #picker></mat-datepicker>
</mat-form-field>
<!-- INPUT WEB CALENDAR -->
<mat-form-field appearance="outline" *ngIf="!ctx.isApp">
  <mat-label>{{ i18 | translate }}</mat-label>
  <input
    matInput
    placeholder="DD/MM/YYYY"
    [min]="minDate"
    [max]="maxDate"
    [matDatepicker]="picker"
    [value]="initValue"
    (dateChange)="onSelectDate($event)"
    required
  />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
